/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CatalogResetRequestDto } from '../models';
// @ts-ignore
import type { CatalogResetSummaryDto } from '../models';
/**
 * RestCatalogResetApi - axios parameter creator
 */
export const RestCatalogResetApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Count what a catalogue reset would delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogResetSummary: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/catalog-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Processes, customers, users, dictionaries and the import history stay. Tasks attached to an offer move to its process. Links to catalogue dishes in PPTX import drafts are cleared. The confirmation must be the phrase USUŃ WSZYSTKO, otherwise 400. 
         * @summary Delete every offer, group set, dish and offer element
         * @param {CatalogResetRequestDto} catalogResetRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetCatalog: async (catalogResetRequestDto: CatalogResetRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'catalogResetRequestDto' is not null or undefined
            assertParamExists('resetCatalog', 'catalogResetRequestDto', catalogResetRequestDto)
            const localVarPath = `/api/catalog-reset`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(catalogResetRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestCatalogResetApi - functional programming interface
 */
export const RestCatalogResetApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestCatalogResetApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Count what a catalogue reset would delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCatalogResetSummary(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogResetSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCatalogResetSummary(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCatalogResetApi.getCatalogResetSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Processes, customers, users, dictionaries and the import history stay. Tasks attached to an offer move to its process. Links to catalogue dishes in PPTX import drafts are cleared. The confirmation must be the phrase USUŃ WSZYSTKO, otherwise 400. 
         * @summary Delete every offer, group set, dish and offer element
         * @param {CatalogResetRequestDto} catalogResetRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetCatalog(catalogResetRequestDto: CatalogResetRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CatalogResetSummaryDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetCatalog(catalogResetRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestCatalogResetApi.resetCatalog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestCatalogResetApi - factory interface
 */
export const RestCatalogResetApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestCatalogResetApiFp(configuration)
    return {
        /**
         * 
         * @summary Count what a catalogue reset would delete
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCatalogResetSummary(options?: RawAxiosRequestConfig): AxiosPromise<CatalogResetSummaryDto> {
            return localVarFp.getCatalogResetSummary(options).then((request) => request(axios, basePath));
        },
        /**
         * Processes, customers, users, dictionaries and the import history stay. Tasks attached to an offer move to its process. Links to catalogue dishes in PPTX import drafts are cleared. The confirmation must be the phrase USUŃ WSZYSTKO, otherwise 400. 
         * @summary Delete every offer, group set, dish and offer element
         * @param {CatalogResetRequestDto} catalogResetRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetCatalog(catalogResetRequestDto: CatalogResetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CatalogResetSummaryDto> {
            return localVarFp.resetCatalog(catalogResetRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestCatalogResetApi - interface
 */
export interface RestCatalogResetApiInterface {
    /**
     * 
     * @summary Count what a catalogue reset would delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCatalogResetSummary(options?: RawAxiosRequestConfig): AxiosPromise<CatalogResetSummaryDto>;

    /**
     * Processes, customers, users, dictionaries and the import history stay. Tasks attached to an offer move to its process. Links to catalogue dishes in PPTX import drafts are cleared. The confirmation must be the phrase USUŃ WSZYSTKO, otherwise 400. 
     * @summary Delete every offer, group set, dish and offer element
     * @param {CatalogResetRequestDto} catalogResetRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetCatalog(catalogResetRequestDto: CatalogResetRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CatalogResetSummaryDto>;

}

/**
 * RestCatalogResetApi - object-oriented interface
 */
export class RestCatalogResetApi extends BaseAPI implements RestCatalogResetApiInterface {
    /**
     * 
     * @summary Count what a catalogue reset would delete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCatalogResetSummary(options?: RawAxiosRequestConfig) {
        return RestCatalogResetApiFp(this.configuration).getCatalogResetSummary(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Processes, customers, users, dictionaries and the import history stay. Tasks attached to an offer move to its process. Links to catalogue dishes in PPTX import drafts are cleared. The confirmation must be the phrase USUŃ WSZYSTKO, otherwise 400. 
     * @summary Delete every offer, group set, dish and offer element
     * @param {CatalogResetRequestDto} catalogResetRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public resetCatalog(catalogResetRequestDto: CatalogResetRequestDto, options?: RawAxiosRequestConfig) {
        return RestCatalogResetApiFp(this.configuration).resetCatalog(catalogResetRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

